

































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';

import createHub from '@/gql/company/createHub.gql';
import updateHub from '@/gql/company/updateHub.gql';

const CommonFormWithBranchEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonAreaCodeSelector,
  },
  props: {
    companyId: { default: -1 },
    hub: { default() { return { id: -1 }; } },
  },
  setup(props: any, { emit }: any) {
    const _hub = reactive({
      id: -1,
      code: '',
      name: '',
      type: '',
      areas: [],
      lat: 0,
      long: 0,
    });
    watch(() => props.hub, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        _hub.id = props.hub.id;
        _hub.code = props.hub.code;
        _hub.name = props.hub.name;
        _hub.type = props.hub.hubType;
        _hub.areas = props.hub.areas;
        _hub.lat = props.hub.lat;
        _hub.long = props.hub.long;
      } else {
        _hub.id = -1;
        _hub.code = '';
        _hub.name = '';
        _hub.type = '';
        _hub.areas = [];
        _hub.lat = 0;
        _hub.long = 0;
      }
    });

    const refetchQueryList = ['getHubs', 'getMyCompany', 'hubs', 'getMyInfo', 'getCompanyHub'];
    const createHubMutation = useMutation(createHub, () => ({
      variables: {
        input: {
          // eslint-disable-next-line
          companyId: props.companyId,
          ..._hub,
          areas: { connect: _hub.areas.map((area: { id: number }) => area.id) },
          hubType: _hub.type,
          lat: parseFloat(_hub.lat as any),
          long: parseFloat(_hub.long as any),
          id: undefined,
          type: undefined,
        },
      },
      refetchQueries: refetchQueryList,
    }));
    const updateHubMutation = useMutation(updateHub, () => ({
      variables: {
        input: {
          ..._hub,
          id: _hub.id,
          areas: { connect: _hub.areas.map((area: { id: number }) => area.id) },
          lat: parseFloat(_hub.lat as any),
          long: parseFloat(_hub.long as any),
          hubType: _hub.type,
          type: undefined,
        },
      },
      refetchQueries: refetchQueryList,
    }));
    const confirmModal = ref(null);
    createHubMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateHubMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createHubMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateHubMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (_hub.id !== -1) return updateHubMutation;
      return createHubMutation;
    });

    return {
      _hub,

      confirmModal,
      errorModal,
      computedMutation,
    };
  },
});

export default CommonFormWithBranchEditor;
